module.exports = __webpack_public_path__ + "img/wb_logo_hk.2fb4ff2d.webp";